import type { IAdaptFileList, IFileListResponse } from './FileList.types'
import { FALLBACK_LOCALE, PRIMARY_LOCALE } from '@/domains/investor/utils/utils'

export const useFileList = () => {

  const { locale } = useI18n()
  const route = useRoute()

  function getFileItems(fileListData: IAdaptFileList | null | undefined) {
    const files = fileListData?.files

    if (Array.isArray(files)) {
      return files
    }

    if (files && typeof files === 'object') {
      const localeKey = locale.value.toLowerCase().startsWith('pl') ? PRIMARY_LOCALE : FALLBACK_LOCALE
      const filesRecord = files as Record<string, unknown>
      const localizedFiles = filesRecord[localeKey]
        ?? filesRecord[PRIMARY_LOCALE]
        ?? filesRecord[FALLBACK_LOCALE]
        ?? Object.values(filesRecord)[0]

      return Array.isArray(localizedFiles) ? localizedFiles : []
    }

    return []
  }

  async function getFileList(id: string) {
    return useAsyncData(
      `fileList-${route.path}-${locale.value}-${id}`,
      async () => {
        const response = await $fetch<IFileListResponse>('/api/v1/contentful/investor/fileList',
          {
            query: {
              id,
              path: route.path,
              locale: locale.value,
            },
          },
        )
        return response.fileList ?? null
      })
  }

  return {
    getFileList,
    getFileItems,
  }
}
